import { Input_Base } from './Input_Base.ts';
import { RadioGroup } from '@services/MarppleShop/renderApp/components/cells/RadioGroup/RadioGroup.ts';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import klass from './Input.module.scss';
import { shareFont } from '@services/MarppleShop/shared/typography';
import { ValidateField } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';

interface item {
  id: string;
  display_name: string;
  value?: unknown;
}

export interface InputRadioGroupData extends Omit<InputEditor, 'value'> {
  selected_id: string;
  items: Array<item>;
  readonly?: boolean;
  onChange?: (view: RadioGroup<unknown>) => void;
}

export class Input_RadioGroup extends Input_Base<InputRadioGroupData> {
  radioGroupView = new RadioGroup(
    {
      name: this.data.name,
      items: this.data.items,
      selected_id: this.data.selected_id,
      onChange: (view) => {
        if (this.data.onChange) {
          this.data.onChange(view);
        }
      },
    },
    {
      readonly: this.data.readonly,
      custom_klass: {
        group: klass.radio_group,
        item: shareFont('14_medium'),
      },
    },
  );

  protected inputTemplate() {
    return this.radioGroupView;
  }

  public get changeEvent() {
    return this.radioGroupView.changeEvent;
  }

  public getName(): ValidateField {
    return this.data.name;
  }

  public override setError() {
    return void 0;
  }

  public getValue() {
    return this.radioGroupView.getSelected()?.value;
  }
}
